import { CommonModule } from '@angular/common';
import { Component, input, ViewEncapsulation } from '@angular/core';

import { ImageSlideComponent } from '@valk-nx/components/ui-slider/src/lib/image-slide/image-slide';
import { SliderNavButtonComponent } from '@valk-nx/components/ui-slider/src/lib/nav-button/nav-button';
import { SliderComponent } from '@valk-nx/components/ui-slider/src/lib/slider';
import type { SliderConfig } from '@valk-nx/components/ui-slider/src/lib/slider.interface';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';

@Component({
	encapsulation: ViewEncapsulation.None,
	host: { class: 'block overflow-x-clip' },
	selector: 'vp-feature-split',
	templateUrl: './feature-split.html',
	imports: [
		CommonModule,
		SliderComponent,
		SliderNavButtonComponent,
		ImageSlideComponent,
	],
})
export class FeatureSplit {
	images = input.required<PhotoInterface[]>();
	inverse = input(false);

	protected readonly sliderConfig: SliderConfig = {
		slidesPerView: 1,
		edgeOffset: 0,
		showNavigation: true,
		fillHeight: true,
		breakpoints: {},
	};
}
